import { useEffect, useState } from "react";
import Head from "next/head";
import Image from "next/image";
import PropTypes from 'prop-types';
import * as dayjs from "dayjs";

import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Select, MenuItem, InputLabel, FormControl } from "@mui/material";

import MainHeader from "../../components/MainHeader";
import MainFooter from "../../components/MainFooter";
import EventThumb from "../../components/EventThumb";
import TabPanel from "../../components/TabPanel";

import { getCookie } from "cookies-next";

import fonts from "../../styles/FontInter.module.css";
import mainTheme from "../../components/mainTheme";
import styles from "../../styles/Home.module.css";
import ExitModal from "../../components/ExitModal";
import FormMini from "../../components/forms/FormMini";

import client from "../../components/client"



export default function TemplatePage({ events, filter, defaultTab }) {
  useEffect(() => {
    dataLayer.push({ event: "optimize.activate" });
  }, []);

  const [value, setValue] = useState(defaultTab);
  const [tagFilter, setFilter] = useState(filter || '');

  const handleChange = (event, newValue) => {
    if(value == 1 && newValue != 1){
      setFilter('');
    }
    if(value != 1 && newValue == 1){
      setFilter('');
    }
    setValue(newValue);
  };
  const handleFilter = (event, newValue) => {
    setFilter(newValue.props.value);
  };

  const tagList = [];
  const regtagList = [];
  for(let event of events){
    for(let cat of event.event_category){
      if(event.event_type == 'physical' || event.event_type == 'regional'){
        if(!regtagList.includes(cat.title)){
          regtagList.push(cat.title);
        }
      }
      else{
        if(!tagList.includes(cat.title)){
          tagList.push(cat.title);
        }
      }
      
    }
    
  }

  const onDemandEvents = events.filter(function(event){
    if(event.event_type == 'ondemand'){
      let showEvent = true;
      if(tagFilter != ''){
        showEvent = false;
        for(let cat of event.event_category){
          if(cat.title == tagFilter){
            showEvent = true;
          }
        }
      }
      if(showEvent){
        return event
      }
    }
  });

  const liveEvents = events.filter(function(event){
    if(event.event_type == 'webinar'){
      let showEvent = true;
      if(tagFilter != ''){
        showEvent = false;
        for(let cat of event.event_category){
          if(cat.title == tagFilter){
            showEvent = true;
          }
        }
      }
      let now = new Date().getTime();
      let eventDate = new Date(event.event_date).getTime();
      if(showEvent && eventDate > now){
        return event
      }
    }
  });

  const inPersonRegional = events.filter(function(event){
    if(event.event_type == 'physical' || event.event_type == 'regional'){
      let showEvent = true;
      if(tagFilter != ''){
        showEvent = false;
        for(let cat of event.event_category){
          if(cat.title == tagFilter){
            showEvent = true;
          }
        }
      }
      let now = new Date().getTime();
      let eventDate = new Date(event.event_date).getTime();
      if(showEvent && eventDate > now){
        return event
      }
    }
  });

  return (
    <ThemeProvider theme={mainTheme}>
      <Head>
        <title>Live Events and Webinars - Elm Street</title>
        <meta name="description" content="Training Webinars - Elm Street" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <CssBaseline className={fonts} />
      <MainHeader />






   
      <ExitModal>
      <div style={{padding:"25px"}}>
                <div style={{textAlign:"center", paddingBottom:"10px"}}> <Typography variant="h4" component="h2" style={{ color: "#333666", textAlign: "center", paddingBottom:"10px" }}>Stay Updated With<br />
                <span style={{color:"#f69c26"}}>Daily Marketing Tips</span></Typography>
                </div>
                <div style={{textAlign:"center", paddingBottom:"10px"}}>Inspire your inner genius! Get the latest marketing &amp; lead gen tips &amp; tricks, straight to your inbox every morning.</div>
                
                  <FormMini buttonText="Get my daily tips" formName="es2_daily_tips" listId="118042" utmOverride="exit_intent" />
                
         </div>
         <div style={{textAlign:"center"}}>
         <Image
                    src="/coffee.jpg"
                    width="590px"
                    height="242px"
                    alt="Stay Updated with Daily Marketing tips"
                   
                  />
                  </div>
     </ExitModal>




      <div
        style={{
          backgroundImage: "url('upcomingbg.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container maxWidth="lg">
          <Grid container>
            <Grid item md={4} sm={12}>
              <div
                style={{
                  color: "#FFFFFF",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  height: "400px",
                }}
              >
                <div>
                <div style={{ paddingTop: "8px" }}>
                      <Image src="/es_academy_logow.svg" width="260px" height="90px" alt="Elm Street Academy"/>
                    </div>
                  <Typography variant="h2" component="h1">
                    <span style={{ color: mainTheme.palette.secondary.main }}>
                      {" "}
                      PICK YOUR<br />
                    </span>{" "}
                    PASSION
                  </Typography>
                  <p>Hot topics for busy professionals.</p>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>

      <Container maxWidth="lg" style={{ paddingLeft: "20px", paddingRight: "20px", paddingTop:"60px", paddingBottom:"60px" }}>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
            <Tab label="National Webinars" id="tab-0" aria-controls="training-0" />
            <Tab label="Regional Events" id="tab-1" aria-controls="training-1" />
            <Tab label="On-Demand Webinars" id="tab-2" aria-controls="training-2" />
            <div style={{flexGrow:"2",textAlign:"right"}}>
              <FormControl variant="standard" sx={{ m: 1, minWidth: 180 }} size="small">
              <InputLabel id="training-select-standard-label">All Categories</InputLabel>
                <Select
                  labelId="training-select-label"
                  id="training-select"
                  label="All Products"
                  onChange={handleFilter}
                  value={tagFilter}
                >
                  <MenuItem value=''>All</MenuItem>
                  {value != 1 && tagList.map(function(tag){
                    return <MenuItem value={tag} key={tag}>{tag}</MenuItem>
                  })}
                  {value == 1 && regtagList.map(function(tag){
                    return <MenuItem value={tag} key={tag}>{tag}</MenuItem>
                  })}
                </Select>
              </FormControl>
            </div>
          </Tabs>
        </Box>
        
        <TabPanel value={value} index={0}>
        <Grid container columnSpacing={8}>
          {liveEvents.length > 0 ? liveEvents.map(function(event){
              return <Grid item xs={12} sm={6} md={4} key={event._id} style={{marginBottom:"16px",marginTop:"16px"}}><EventThumb event={event} client={client} key={event._id} type={event.event_type}/></Grid>
            }) : <Grid item xs={12} sm={6} md={6}>
            <p>There are no live webinars scheduled at this time.</p>
            </Grid>}
          </Grid>
        </TabPanel>
        <TabPanel value={value} index={1}>
        <Grid container columnSpacing={8}>
          {inPersonRegional.length > 0 ? inPersonRegional.map(function(event){
              return <Grid item xs={12} sm={6} md={4} key={event._id} style={{marginBottom:"16px",marginTop:"16px"}}><EventThumb event={event} client={client} key={event._id} type={event.event_type}/></Grid>
            }) : <Grid item xs={12} sm={6} md={6}>
            <p>There are no regional events scheduled at this time.</p>
            </Grid>}
          </Grid>
        </TabPanel>
        <TabPanel value={value} index={2}>
          <Grid container columnSpacing={8} >
            {onDemandEvents.length > 0 ? onDemandEvents.map(function(event){
              return <Grid item xs={12} sm={6} md={4} key={event._id} style={{marginBottom:"16px",marginTop:"16px"}}><EventThumb event={event} client={client} key={event._id} type={event.event_type}/></Grid>
            }) : <Grid item xs={12} sm={6} md={6}>
            <p>There are no on-demand webinars.</p>
            </Grid>}
          </Grid>
        </TabPanel>
      </Box>
      
      </Container>

      <MainFooter />
    </ThemeProvider>
  );
}

export async function getServerSideProps(context) {
  let defaultTab = 0; // National Webinars by default

  if(context.query && context.query.tab){
    if(context.query.tab === "on-demand"){
      defaultTab = 2;
    }
    if(context.query.tab === "regional"){
      defaultTab = 1;
    }
  }


  let start = 0;
  let length = 2;
  let postCount = 0;
  let displayPosts = [];

  if(context.query && context.query.p){
    start = (context.query.p - 1) * length
  }
  let end = start + length;

  const postQuery = `
  *[_type == "event" &&  !("Training" in event_category[]->title)] | order(event_date asc){
    _id,
    title,
    event_date,
    event_type,
    event_category[]->{
      title
    },
    duration,
    description,
    thumbnail,
    reg_url,
    tags[]->{
      tag
    }
  }
  `

  const events = await client.fetch(
      postQuery
  )
  
  let formattedDate = dayjs().format('YYYY-MM-DD');
  const contentfulQuery = `{ eventCollection(where:{datetime_gt:"${formattedDate}"}, order:[datetime_ASC]){
    items {
      datetime
      title
      location
      registrationUrl
      physicalAddress
      eventType
      mls
      slug
      eventStatus
      landingLayout
    }
  }
  }`

  const fetchUrl = `https://graphql.contentful.com/content/v1/spaces/${process.env.CF_SPACE_ID}`;

  const body = JSON.stringify({ query: contentfulQuery });

  const fetchOptions = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${process.env.CF_DELIVERY_ACCESS_TOKEN}`,
      "Content-Type": "application/json",
    },
    body,
  };

  const data = await fetch(fetchUrl, fetchOptions).then((response) => response.json());
  
  let contentfulEvents = data.data.eventCollection.items;
  let thumbMap = {
    "SM": "/event_thumbnails/socialmedia.jpg",
    "LG": "/event_thumbnails/leadgen.jpg",
    "FBAds": "",
    "RM": "/event_thumbnails/referral.jpg",
    "LN": "/event_thumbnails/nurture.jpg",
    "Webinar": "",
    "Listings": "/event_thumbnails/listings.jpg",
    "Other": ""
  }
  let catMap = {
    "SM": "Social Media Boot Camp",
    "LG": "Lead Generation Boot Camp",
    "FBAds": "Facebook Leads Boot Camp",
    "RM": "Referrals Boot Camp",
    "LN": "Lead Nurture Boot Camp",
    "Webinar": "Webinars",
    "Listings": "Listings Boot Camp",
    "Other": "Other"
  }
  for(let event of contentfulEvents){
    let newEvent ={
      _id: event.title.replace(" ","").toLowerCase()+event.datetime,
      title: event.title,
      event_date: event.datetime,
      event_type: event.physicalAddress === null ? "regional" : "physical",
      reg_url: event.registrationUrl,
      description: event.location,
      event_category: [
        {title: catMap[event.eventType]}
      ],
      tags: [
        {tag: catMap[event.eventType]}
      ],
      thumbnail: thumbMap[event.eventType]
    }
    events.push(newEvent);
  }

  let filter = '';
  if(context.query && context.query.f){
    filter = context.query.f;
  }

  return {
    props: {
        events,
        filter,
        defaultTab,
    },
  }
}
